import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { IconButtonComponent } from '../../../common/buttons/icon-button/icon-button.component';

@Component({
    imports: [IconButtonComponent],
    selector: 'product-wishlist-toggle',
    templateUrl: 'product-wishlist-toggle.html',
    styleUrl: 'product-wishlist.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductWishlistToggleComponent extends WishlistToggleComponentDef implements OnInit {
    @Input()
    fontSize = 20;
}
